import type { CityConfig } from "../city-template/types";

export const wellsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Maine CDC Vital Records", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine vital records office in Augusta" },
    { label: "Marriage Licenses — York County Clerk", href: "https://www.yorkcountymaine.gov/", description: "York County Clerk — marriage license issuance" },
    { label: "Divorce Records — York County Clerk", href: "https://www.yorkcountymaine.gov/", description: "York County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Wells",
  state: "Maine",
  stateAbbr: "ME",
  slug: "wells",
  route: "/cities/wells",
  title: "Emergency Passport Wells, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Wells, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Wells, Kennebunk, Ogunquit, York, and southern York County. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Wells, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Wells and southern Maine travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wells%20Maine%20scenic%20coastal%20view%20with%20sandy%20beach%20and%20ocean%20waves%2C%20southern%20Maine%20beach%20town%20with%20classic%20New%20England%20cottages%20and%20grassy%20dunes%2C%20Drakes%20Island%20and%20Wells%20Beach%20with%20blue%20Atlantic%20waters%2C%20summer%20afternoon%20light%2C%20professional%20travel%20photography%2C%20wide%20angle%20scenic%20view%20of%20Wells%20Maine%20coastline&width=1800&height=700&seq=wells-me-hero-001&orientation=landscape",
  heroImageAlt: "Wells Maine scenic coastal beach with sandy dunes and ocean waves",
  geoPosition: "43.3223;-70.5805",
  geoPlacename: "Wells, Maine",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 75 miles (1.5 hours) from Wells, ME",
  },
  nearbyCitiesZips: [
    { name: "Wells", zips: "04090" },
    { name: "Kennebunk", zips: "04043" },
    { name: "Ogunquit", zips: "03907" },
    { name: "York", zips: "03909" },
    { name: "Sanford", zips: "04073" },
    { name: "Arundel", zips: "04046" },
    { name: "Acton", zips: "04001" },
    { name: "Kennebunkport", zips: "04046" },
    { name: "Biddeford", zips: "04005" },
    { name: "Saco", zips: "04072" },
    { name: "Kittery", zips: "03904" },
    { name: "South Berwick", zips: "03908" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Wells departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Kennebunk", route: "/cities/kennebunk" },
    { name: "Emergency passport help in Ogunquit", route: "/cities/ogunquit" },
    { name: "Urgent passport services in York", route: "/cities/york-me" },
    { name: "Same-day passport help in Biddeford", route: "/cities/biddeford" },
    { name: "Expedited passport services in Saco", route: "/cities/saco" },
    { name: "Passport courier services in Portland", route: "/cities/portland-me" },
    { name: "Rush passport help in Sanford", route: "/cities/sanford" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Wells, Maine remotely via secure courier. We do not have a walk-in office in Wells — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Wells travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving the greater Wells and southern York County area",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Wells and southern York County. From the sandy shores of Wells Beach and Drakes Island to the quiet neighborhoods of Arundel and Acton — we help Wells travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Wells neighborhoods and nearby towns including Kennebunk, Ogunquit, York, Sanford, Arundel, Acton, Kennebunkport, Biddeford, Saco, Kittery, and South Berwick.",
  howItWorksIntro: "Most Wells travelers complete everything online and ship documents overnight. No need to drive to Boston or Portland. Our emergency and expedited passport process is designed for Maine travelers who need fast, reliable results.",
  mistakesIntro: "Wells is a popular summer beach destination with many seasonal residents and vacation home owners. Visitors and residents often need passports at short notice. Here are the most common mistakes we see from Wells-area travelers.",
  testimonialsIntro: "Wells travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Wells? Here are the most common ones we hear from southern York County travelers.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Wells international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Karen W.",
      location: "Wells, ME",
      rating: 5,
      text: "Realized my passport was expired 5 days before our Caribbean cruise. Fast Passport Center got my renewal done in 2 days. From Wells to the Caribbean with zero worries. These folks are lifesavers.",
      service: "Passport Renewal",
    },
    {
      name: "Brian N.",
      location: "Kennebunk, ME",
      rating: 5,
      text: "Emergency business trip to London with 3 days notice. Fast Passport Center had my emergency passport ready in 24 hours. I shipped from the Wells area and had it back the next morning.",
      service: "Emergency Passport",
    },
    {
      name: "Diane F.",
      location: "Ogunquit, ME",
      rating: 5,
      text: "Lost my passport right before our anniversary trip to Italy. Fast Passport Center handled the DS-64 form and had my replacement in 3 days. They saved our trip completely.",
      service: "Lost Passport",
    },
    {
      name: "Steve J.",
      location: "York, ME",
      rating: 5,
      text: "Passport renewal for our son's school trip to Quebec. Fast Passport Center helped us navigate the process and got the passport in 4 days. The whole process was so smooth.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "wells-1",
      name: "Wells Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1260 Post Rd",
      city: "Wells",
      state: "ME",
      zip: "04090",
      phone: "(207) 646-2464",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "In the center of Wells",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main passport acceptance facility for Wells. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "wells-2",
      name: "Kennebunk Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17 Portland St",
      city: "Kennebunk",
      state: "ME",
      zip: "04043",
      phone: "(207) 985-3311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles from Wells",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with more appointment slots. Popular for Wells and Kennebunk residents.",
      icon: "ri-mail-line",
    },
    {
      id: "wells-3",
      name: "York Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "20 Woodbridge Rd",
      city: "York",
      state: "ME",
      zip: "03909",
      phone: "(207) 363-2040",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles from Wells",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Good option for Wells residents near York.",
      icon: "ri-mail-line",
    },
    {
      id: "wells-4",
      name: "Biddeford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "35 Alfred St",
      city: "Biddeford",
      state: "ME",
      zip: "04005",
      phone: "(207) 282-2913",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles from Wells",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility in the region. Most appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "wells-5",
      name: "Wells Town Office",
      type: "Municipal Passport Acceptance",
      address: "1430 Post Rd",
      city: "Wells",
      state: "ME",
      zip: "04090",
      phone: "(207) 646-5111",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "In downtown Wells",
      website: "https://www.wellsmaine.gov/",
      websiteLabel: "Wells Town Office",
      notes: "Town clerk services. Call ahead to confirm passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "wells-6",
      name: "Sanford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "850 Main St",
      city: "Sanford",
      state: "ME",
      zip: "04073",
      phone: "(207) 324-5461",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles from Wells",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "York County inland option. Backup for Wells area.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local Wells photo shops may use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wells acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Wells applicants show up with incorrect checks and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Wells families.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Wells travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location near Wells." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Wells address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Wells, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Wells in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays.",
    },
    {
      q: "Can I get a same-day passport in Wells, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option.",
    },
    {
      q: "Where can I get a fast passport renewal in Wells, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Wells with no office visit required. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "How far is Wells from the Boston Passport Agency?",
      a: "Wells is approximately 75 miles from the Boston Passport Agency — about a 1.5-hour drive. With Fast Passport Center, you avoid that trip entirely.",
    },
    {
      q: "What acceptance facilities are near Wells, Maine?",
      a: "Options near Wells include the Wells Post Office (04090), Kennebunk Post Office (04043), York Post Office (03909), and Wells Town Office (04090). The Wells Post Office on Post Rd is most convenient.",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery.",
    },
    {
      q: "Is Wells close to Portsmouth or Portland airports?",
      a: "Yes, Portsmouth International Airport (PSM) is about 25 miles from Wells. Portland Jetport (PWM) is about 35 miles. Portsmouth is the closest for Wells travelers.",
    },
    {
      q: "How much does expedited passport service cost in Wells?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a quote.",
    },
    {
      q: "What documents do I need for a first-time passport in Wells?",
      a: "You'll need proof of citizenship, government-issued photo ID, two passport photos, and payment. We provide a complete checklist and review your documents.",
    },
    {
      q: "Can you help with a child's passport in Wells?",
      a: "Yes. Child passports require both parents (or notarized consent), the child's birth certificate, and both parents' IDs. We walk Wells families through the process.",
    },
    {
      q: "Is there a UPS Store near Wells for shipping documents?",
      a: "Yes, there are UPS locations in Kennebunk, Biddeford, and Saco. We provide a prepaid overnight label. The Wells Post Office on Post Rd also accepts packages.",
    },
    {
      q: "Can I get passport photos taken in Wells?",
      a: "Yes, CVS and Rite Aid in the Wells-Kennebunk area offer passport photo services. The Walgreens and CVS in Kennebunk are also convenient options.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Wells", address: "1300 Post Rd, Wells, ME 04090", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Kennebunk", address: "17 Portland St, Kennebunk, ME 04043", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Kennebunk", address: "25 Main St, Kennebunk, ME 04043", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Biddeford", address: "35 Alfred St, Biddeford, ME 04005", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Biddeford", address: "50 Mariner Way, Biddeford, ME 04005", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Photo Center — Biddeford", address: "50 Mariner Way, Biddeford, ME 04005", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Rite Aid — Kennebunk", address: "25 Main St, Kennebunk, ME 04043", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — South Portland", address: "200 John Roberts Rd, South Portland, ME 04106", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "BMV — Biddeford",
      address: "35 Alfred St, Biddeford, ME 04005",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service BMV. 10 miles from Wells. Online appointment booking available.",
      featured: true,
    },
    {
      name: "BMV — Sanford",
      address: "1250 Main St, Sanford, ME 04073",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "York County option. 15 miles from Wells.",
      featured: false,
    },
    {
      name: "BMV — Portland",
      address: "25 Middlesex St, Portland, ME 04101",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Largest facility in the region. 35 miles from Wells.",
      featured: false,
    },
    {
      name: "BMV — Portsmouth (NH)",
      address: "15 Dartmouth St, Portsmouth, NH 03801",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "New Hampshire option. 25 miles from Wells.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PSM",
      name: "Portsmouth International Airport",
      distance: "25 miles from Wells (30 min)",
      address: "68 miles from Wells (1.1 hour)",
      note: "Closest airport to Wells with flights to major hubs. A great option for southern York County travelers.",
      flightUrl: "https://www.flyportsmouth.com/",
      flightLabel: "Portsmouth Airport",
      featured: true,
    },
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "35 miles from Wells (40 min)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport. Direct flights to Boston, New York, Chicago, and Philadelphia. Good option for Wells travelers.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: false,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "75 miles from Wells (1.5 hours)",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many Wells travelers drive to Boston for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan Airport",
      featured: false,
    },
  ],
};